import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-toolguide-modal',
    templateUrl: './toolguide-modal.component.html',
    styleUrls: ['./toolguide-modal.component.less'],
  standalone: false
})
export class ToolguideModalComponent implements OnInit {
    visible = false;
    
    constructor() { }

    ngOnInit(): void {
        return;
    }

    openModal(): void {
        this.visible = true;
    }

    closeModal(): void {
        this.visible = false;
    }
}